// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__MS-yL"};